var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('headernav'),_c('div',{staticClass:"mt5 mb5 min-height"},[_c('router-view')],1),_c('Footer'),_c('AudioPlayer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }